import React from "react";
import cssStyles from "./cms_renderer.module.scss";
import { transformDescription } from "./shared";
import { SectionData, ComponentRenderProps, renderFunctions } from "./index";

import { trackItem } from "@/utils";

interface CirclerImageButtonProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
    index?: number;
}

const CirclerImageButton = ({ sectionData, props, index = 1 }: CirclerImageButtonProps): JSX.Element | null => {
    const baseClassName = "imgButtonCircular";
    const styles = sectionData.uiCompType?.styles || {};
    const title = sectionData.title || sectionData.name || sectionData.text;
    const shouldUseMarkdown = sectionData.uiCompType?.options?.markdown || false;

    return (
        <div key={String(sectionData.trackId || index)} className={cssStyles[baseClassName]} style={styles}>
            <div
                style={{ ...sectionData.uiCompType?.containerStyles }}
                className={cssStyles[`${baseClassName}__outerCircle`]}
                onClick={(e) => { trackItem(sectionData.trackInfo || {}); }}
            >
                <div
                    className={cssStyles[`${baseClassName}__innerCircle`]}
                    style={{
                        height: sectionData.uiCompType?.options?.height || 200,
                        width: sectionData.uiCompType?.options?.width || 200,
                    }}
                >
                    <div
                        className={cssStyles[`${baseClassName}__circle`]}
                        style={{ backgroundImage: `url(${sectionData.imageUrl})` }}
                    >
                    </div>
                </div>
            </div>

            {title && (shouldUseMarkdown ? transformDescription(title, "", sectionData.trackId + "_title", sectionData.uiCompType?.styles, undefined, props) :
                (() => {
                    const CustTextComponent = renderFunctions.CustText;
                    return <CustTextComponent sectionData={{
                        text: title,
                        uiCompType: {
                            ...sectionData.uiCompType,
                            options: {
                                ...sectionData.uiCompType?.options
                            },
                            styles: {
                                textAlign: 'center',
                                ...sectionData.uiCompType?.styles,
                            }
                        }
                    }} props={props} />;
                })()
            )}
        </div>
    );
}
export default CirclerImageButton;
